import { DownloadOptions } from "@portal/hooks/useDownlodDocument";
import { GF_URL } from "@portal/lib/ky/type";
import { apiRequest } from "@portal/lib/ky/utils";

export async function downloadReports<T>(
  url: GF_URL,
  options: DownloadOptions<T>
) {
  return apiRequest<DownloadOptions<T>["data"], T>({
    url,
    method: "POST",
    data: options.data,
  });
}

export async function download<T>(url: GF_URL, options: DownloadOptions<T>) {
  return apiRequest<DownloadOptions<T>["data"], T>({
    url,
    method: "POST",
    data: options.data,
  });
}

export async function getAttachmentUrl(attachmentId: string) {
  const data = await apiRequest<unknown, { expiry_link: string }>({
    url: `v1/attachments/${attachmentId}/expiry-link?`,
    method: "GET",
  });
  return await data.json();
}
